import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SiteDetailAlertService } from '../site-detail-alert/site-detail-alert.service';

@Component({
  selector: 'app-site-detail-alert-wind',
  templateUrl: './site-detail-alert-wind.component.html',
  styleUrls: ['./site-detail-alert-wind.component.scss'],
})
export class SiteDetailAlertWindComponent implements OnChanges {
  @Input() date: string = '';

  isOuter = false; // 外部のユーザかどうか

  constructor(private siteDetailAlertService: SiteDetailAlertService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.isOuter = this.siteDetailAlertService.isOuterUser();
  }
}
